import { createApp, ref } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { supabase } from "@/hooks/supabase/supabase"
import useSupabaseAuth from "@/hooks/supabase/auth";
import useToast from '@/hooks/toast'
import VueDayjs from 'vue3-dayjs-plugin'
//import { DisableSwipeBackDirective } from 'v-disable-swipe-back';
import { DisableSwipeBackDirective } from '@/utils/v-disable-swipe-back';
import VueScrollTo from 'vue-scrollto'
import VueSocialSharing from 'vue-social-sharing'

//Deep Link
import { App as CapacitorApp, URLOpenListenerEvent } from '@capacitor/app';

const { snsSignupCallback } = useSupabaseAuth();
const { setToast } = useToast()

const app = createApp(App)
  .use(IonicVue)
  .directive('disable-swipe-back', DisableSwipeBackDirective);

//
app.use(router);
router.isReady();
app.use(VueDayjs);
app.use(VueSocialSharing);
app.mount("#app");
defineCustomElements(window);  
/*
authCheck()
.then(() => {
  app.use(router);
  router.isReady();
})
.then(() => {
  app.use(VueDayjs);
  app.mount("#app");
  defineCustomElements(window);  
});
*/

/* App用 */
/*
CapacitorApp.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {

  //ToDo 一旦登録処理のみで対応する
  const { type } = await snsSignupCallback(event)

  if(type === 'email'){
    await setToast("メール認証が完了しました。", "bottom")
    router.push('/signin')
  }
  if(type === 'oAuth'){
    router.push('/')
  }
  if(type === 'error'){
    console.log("type", type)
    await setToast("認証に失敗しました。もう一度お願いいたします。", "bottom")
    router.push('/signin')
  }

});
*/

/* 
https://codama-deep-link.vercel.app/
#access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.GsWkUHqXx7moW_fExBR684lrZnxvksg1C6ZVmfREm20
&expires_in=3600
&provider_token=ya29.a0AWY7Ckm824piNwdUA6FqsBV-9XsuRqpNdClyCW9Sv6OZuSht_OGEYusTE7BpcRfeopzgfkoRLRixH57Dv5riKlF7ec6uHyZMclw6UULnc90bQrKDRzVdeyrMMkRJbHOv81BQy1e8ck5bv1dpCEmwQsnsy02fZwaCgYKAWYSARASFQG1tDrps3oSJJVQfpju0qRGwUceEQ0165
&refresh_token=SCTj5P4gIfCTxx5Q8L524g
&token_type=bearer"
*/